// extracted by mini-css-extract-plugin
export default {"like":"_2gZgq","not-clickable":"Tb_bp","notClickable":"Tb_bp","likebutton":"_3fC2z","likes":"_2-A_H"};